import { useEffect, useState, useRef } from 'react';

import { SystemAccess, } from '../../classess/systemAccess/systemAccess';
import { Status, } from '../../classess/status/status';
import { Customer, } from '../../classess/customer/customer';
import { User, } from '../../classess/user/user';

import { GlobalFormats } from '../../classess/main/globalFormats';

import {
    awaitDelayAsync, badgetStatusGeneric, getProcessButtons, dataTableLanguaje, setDateTimeFormatGlobalString, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj, getResponse,
    LoadingSection, handleResponseMessageAsync, getRolesType, settings, styles, getUserRoles,
} from '../../helpers/main';
import useAuth from '../../auth/UseAuth';
import { SystemAccessService } from '../../services/systemAccesses/SystemAccessService';
import Menu from '../main/Menu';
import Swal from 'sweetalert2';
import AccessDenied from '../main/AccessDenied';
import TableIndex from '../main/TableIndex';

const $ = window.jqGlobal || window.jQuery;

const { app, backend, icons, html, images, labels, messages, timers } = settings;

const currentMethod = 'SystemAccesses';

export default function SystemAccesses({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const userRole = auth?.userRole({ languageId: languageObj?.id, subMethod: currentMethod })?.result || '';
    let userRoles = getRolesType();
    userRoles = getUserRoles({ userRole: userRole, subMethod: currentMethod, })?.result;
    const dtSystemAccessesId = 'dtSystemAccesses';
    const isMount = useRef(true);
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({
        showLoading: false,
        addSystemAccess: false,
    });
    const systemAccessUrl = {
        create: `${backend?.urls?.systemAccesses}/${labels?.create?.en?.trim()?.toLowerCase()}/0`,
        edit: `${backend?.urls?.systemAccesses}/${labels?.edit?.en?.toLowerCase()}/`,
        details: `${backend?.urls?.systemAccesses}/${labels?.details?.en?.toLowerCase()}/`,
    };
    const controls = {
        buttons: {
            addSystemAccess: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnAddSystemAccess',
            },
            back: {
                defaultClass: 'btn btn-sm btn-outline-success mx-1',
                id: 'btnBack',
            },
        },
        dataTables: {
            systemAccesses: {
                buttons: {
                    process: {
                        id: 5,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtSystemAccessesId}_filter input`,
                        defaultClass: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtSystemAccessesId}_length select`,
                        defaultClass: '',
                    },
                },
                paginateds: {
                    paginated: {
                        id: `${dtSystemAccessesId}_paginate`,
                        defaultClass: '',
                    }
                }
            },
        },
        icons: {
            addSystemAccess: {
                id: 'iconAddSystemAccess',
                defaultClass: icons?.fasFa?.plusCircle,
            },
            back: {
                id: 'iconBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        spiners: {
            addSystemAccess: {
                id: 'spAddSystemAccess',
                defaultClass: '',
            }
        },
    };
    //#endregion variables

    //#region methods
    //#region systemaccess
    const systemAccessAddGetAsync = async ({
        e = {},
        subMethod = ''
    } = {}) => {
        const currentMethod = 'systemAccessAddGetAsync';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            //#region check role
            if (userRoles?.isAnonymous) {
                response = getResponse({ type: 1 });
                response.msgText += `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id]}.<br/>`;
                return;
            }
            //#endregion check role

            setProcess(prev => ({ ...prev, showLoading: true, addSystemAccess: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond });

            window.location.href = systemAccessUrl?.create;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false, addSystemAccess: false }));
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const SystemAccessEditDetailsGetAsync = async ({
        e = {},
        id = 0,
        type = 0,
        subMethod = ''
    } = {}) => {
        const currentMethod = 'SystemAccessEditDetailsGetAsync';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, showLoading: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond });

            window.location.href = type === 1 ? `${systemAccessUrl?.edit}${id}` : `${systemAccessUrl?.details}${id}`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false }));
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const systemAccessDeleteAsync = async ({
        e = {},
        id = 0,
        description = '',
        rowId = 0,
        subMethod = ''
    } = {}) => {
        const currentMethod = 'systemAccessDeleteAsync';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            //#region show message
            const msgTextObj = {
                one: `${messages?.areYouShureDeleteThis?.[languageObj?.id]}`,
                two: `${labels?.parameter?.[languageObj?.id]}: <b>${description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            const swalProperties = {
                icon: settings?.react?.sweetAlert2?.messages?.types?.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                showConfirmButton: !Swal.isLoading(),
                confirmButtonColor: settings?.colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: !Swal.isLoading(),
                cancelButtonColor: settings?.colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                            title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        preConfirmResponse = await SystemAccessService.delete({
                            auth,
                            id,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });

                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) {
                            return preConfirmResponse;
                        }

                        $(`#${dtSystemAccessesId}`)?.DataTable()?.row(rowId)?.remove()?.draw(true);

                        preConfirmResponse = getResponse({
                            type: 0,
                            msgText: messages?.processCompletedSuccessfully?.[languageObj?.id]
                        });
                    } catch (ex) {
                        preConfirmResponse = getResponse({ type: -1 });
                        preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                            preConfirmResponse.msgText += `Sub method: ${subMethod}<br/>`;
                        }
                        preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                    }
                    return preConfirmResponse;
                }
            };

            const swalResult = await Swal.fire({ ...swalProperties });
            if (swalResult?.isConfirmed && swalResult?.value) {
                response = swalResult?.value;
            } else if (swalResult?.isDismissed) {
                response = getResponse({ type: 0 });
            }
            //#endregion show message
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }
    //#endregion systemaccess

    //#region others
    const getData = async ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            let usersData = [];
            let customersData = [];
            let statusData = [];
            let systemAccessesData = [SystemAccess?.class({}, false)];

            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                response = setDataTables({ subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;

                response = setQueryCode({ subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;

                response = await SystemAccessService.getAll({
                    auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;

                customersData = response?.result?.customers || [];
                customersData?.sort((a, b) => a.name > b.name ? 1 : -1);
                systemAccessesData = response?.result?.systemAccesses || [];
                systemAccessesData = systemAccessesData?.sort((a, b) => a?.id > b?.id ? 1 : -1);
                statusData = response?.result?.status || [];
                usersData = response?.result?.users || [];

                if (!isUndNullEmp({ data: systemAccessesData, subMethod: currentMethod })?.result && systemAccessesData?.length > 0) {
                    response = setDataInDataTable({
                        data: systemAccessesData,
                        customers: customersData,
                        users: usersData,
                        status: statusData,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
            } else {
                setShowData(false);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false }));
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const setDataTables = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'setDataTables';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtSystemAccessesId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.id?.[languageObj?.id], width: '5%', },
                    { title: labels?.status?.[languageObj?.id], width: '10%', },
                    { title: labels?.register?.[languageObj?.id], width: '15%', },
                    { title: labels?.customer?.[languageObj?.id], width: '45%', },
                    { title: labels?.user?.[languageObj?.id], width: '20%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                //order: [[0, 'asc']],
                order: [[0, 'desc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtSystemAccessesId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let id_ = '';
            let methodName = '';
            let description = '';
            let rowId = 0;
            //#endregion variables

            //#region process
            $(`#${dtSystemAccessesId} tbody`).on('click', 'tr', 'td', async function (e) {
                rowId = getDtRowIndex({ dtId: dtSystemAccessesId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    methodName = e?.target?.attributes?.method?.value || '';
                    id_ = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            SystemAccessEditDetailsGetAsync({ e: e, id: parseInt(id_), description: description, type: 1, rowId: rowId, subMethod: currentMethod, });
                            break;
                        case 'details':
                            SystemAccessEditDetailsGetAsync({ e: e, id: parseInt(id_), description: description, type: 2, rowId: rowId, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            systemAccessDeleteAsync({ e: e, id: parseInt(id_), description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        data = [],
        customers = [],
        users = [],
        status = [],
        subMethod = ''
    } = {}) => {
        const currentMethod = 'setDataInDataTable';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let rowsDt = [];
            let statusObj = {
                finalized: {
                    label: labels?.finalized?.en,
                    model: Status?.getClass({}, false),
                },
            };
            //#endregion variables

            //#region process
            statusObj = {
                ...statusObj,
                finalized: {
                    ...statusObj?.finalized,
                    model: status?.filter(({ name, label, }) => label === statusObj?.finalized?.label || name === statusObj?.finalized?.label)?.[0] || {},
                },
            };

            data?.forEach((systemAccess) => {
                //#region variables
                const modelSystemAccess = SystemAccess?.class(systemAccess, false);
                let modelCustomer = Customer?.getClass({}, false);
                modelCustomer = customers?.filter(({ id, }) => id === modelSystemAccess?.customerId)?.[0] || {};
                let systemAccessStatusObj = {
                    model: Status?.getClass({}, false),
                    label: '',
                    labelHtml: '',
                };
                systemAccessStatusObj.model = status?.filter(({ id, }) => id === modelSystemAccess?.statusId)?.[0] || {}
                //systemAccessStatusObj.label = systemAccessStatusObj?.model?.name;
                systemAccessStatusObj.label = !isUndNullEmp({ data: systemAccessStatusObj?.model?.label, subMethod: currentMethod }) ?
                    systemAccessStatusObj?.model?.label :
                    `${systemAccessStatusObj?.model?.name?.replace(' ', '')?.charAt(0)?.toLowerCase()}${systemAccessStatusObj?.model?.name?.replace(' ', '')?.slice(1)}`;
                systemAccessStatusObj.labelHtml = badgetStatusGeneric({
                    type: (systemAccessStatusObj?.model?.id === 1 ? 1 :
                        (systemAccessStatusObj?.model?.id === 2 ? 5 :
                            (systemAccessStatusObj?.model?.id === 3 ? 3 :
                                (systemAccessStatusObj?.model?.id === 4 ? 0 :
                                    (systemAccessStatusObj?.model?.id === 5 ? -1 :
                                        (systemAccessStatusObj?.model?.id === 6 ? 2 : 4)))))),
                    //value: systemAccessStatusObj?.model?.name,
                    value: labels?.[systemAccessStatusObj?.label]?.[languageObj?.id] || 'undefined',
                });
                let userObj = {
                    model: User?.getClass({}, false),
                    label: '',
                    labelHtml: '',
                };
                userObj.model = users?.filter(({ id, }) => id === modelSystemAccess?.userId)?.[0] || {}
                userObj.label = `${userObj?.model?.firstName || ''} ${userObj?.model?.lastName || ''}`;
                userObj.labelHtml = userObj?.label;
                const registerDate = setDateTimeFormatGlobalString({
                    date: modelSystemAccess?.registerDate,
                    dateFormat: languageObj?.format?.date?.f1,
                    timeFormat: 0,
                    withSeconds: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                const processButtonObj = {
                    //showDelete: ((userRoles?.isAdmin || userRoles?.isAnalyst) && (systemAccessStatusObj?.model?.id !== statusObj?.finalized?.model?.id)),
                    showDelete: ((userRoles?.isAdmin) && (systemAccessStatusObj?.model?.id !== statusObj?.finalized?.model?.id)),
                    showEdit: ((userRoles?.isAdmin || userRoles?.isAnalyst) && (systemAccessStatusObj?.model?.id !== statusObj?.finalized?.model?.id)),
                };
                const processButtons = [];
                //#endregion variables

                //#region process
                rowsDt.push([
                    modelSystemAccess?.id || 0,
                    systemAccessStatusObj?.labelHtml || '',
                    registerDate || '',
                    modelCustomer?.name || '',
                    userObj?.labelHtml || '',
                    getProcessButtons({
                        id: systemAccess?.id,
                        description: modelCustomer?.name,
                        showDetails: true,
                        labelDetails: labels?.details?.[languageObj?.id],
                        enabledDetails: true,
                        showDelete: processButtonObj?.showDelete,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: processButtonObj?.showDelete,
                        showEdit: processButtonObj?.showEdit,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: processButtonObj?.showEdit,
                        processButtons: processButtons,
                    })?.result,
                ]);
                //#endregion process
            });
            $(`#${dtSystemAccessesId}`)?.DataTable()?.rows?.add(rowsDt)?.draw(true);
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => { isMount.current = false; };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods
    return (
        <div>
            <Menu viewName={app?.views?.systemAccesses?.systemAccesses} process={app?.views?.systemAccesses?.systemAccesses} />

            <div className='content-wrapper bg-transparent'>

                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.systemAccesses?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.systemAccesses?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt='systemAccesses' style={styles?.cardHeaderLogo} src={images?.icons?.systemAccesses}></img>
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.systemAccesses?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={html?.badges?.micro}>
                                                                <i className={`${icons?.fasFa?.key} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className='ml-auto'>
                                                        <button id={controls?.buttons?.addSystemAccess?.id}
                                                            type='button'
                                                            hidden={userRoles?.isAnonymous}
                                                            disabled={userRoles?.isAnonymous || process?.showLoading}
                                                            className={process?.addSystemAccess ? `${controls?.buttons?.addSystemAccess?.defaultClass} ${settings?.react?.html?.button?.classes?.disabled}` : controls?.buttons?.addSystemAccess?.defaultClass}
                                                            title={labels?.add?.[languageObj?.id]}
                                                            onClick={(e) => systemAccessAddGetAsync({ e: e, subMethod: controls?.buttons?.addSystemAccess?.id })}
                                                            style={{ borderRadius: '5px' }}>
                                                            {process?.addSystemAccess ? (
                                                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                            ) : (
                                                                <i id={controls?.icons?.addSystemAccess?.id} className={controls?.icons?.addSystemAccess?.defaultClass} />
                                                            )} {labels?.add?.[languageObj?.id]}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-4'>
                                                <TableIndex tableId={dtSystemAccessesId} languageObj={languageObj} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}

                    </div>
                </section>

            </div>
        </div>
    )
}